<template>
  <div class="item-card-global">
    <div class="item-card">
      <div class="header">
        <slot name="header"></slot>
        <div class="buttons">
          <slot name="buttons"></slot>
        </div>
      </div>
      <div class="contentt">
        <slot name="content"></slot>
      </div>
      <div class="footerr">
        <slot name="footer"></slot>
      </div>
    </div>
    <div class="state">
      <h-b-action
        :text="stateText"
        :positive="statePositive"
        :color="stateColor"
        size="sm"
        @click.native="$emit('clickState')"
      ></h-b-action>
    </div>
  </div>
</template>

<script>
export default {
  name: 'item-card',

  props: {
    stateText: {
      type: String,
      default: '',
    },
    stateColor: {
      type: String,
      default: 'primary',
    },
    statePositive: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style scoped></style>
